import spinnerIcon from '@iconify/icons-material-symbols/progress-activity';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Icon } from '#pie/components/icon/Icon';
import { Page } from '#pie/components/page/Page';
import { PageHeader } from '#pie/components/page/page-header/PageHeader';
import { RemoveCprContactpersonButton } from '#pie/components/remove-cpr-contactperson-button/RemoveCprContactpersonButton';
import { useGetManagementContact } from '#pie/internal/api/pie-bff';
import { ErrorPage } from '#pie/pages/error-page/ErrorPage';
import { ContactGroupSection } from './ContactGroupSection';
import { PersonalDataSection } from './PersonalDataSection';

export const UpdateContactPerson = () => {
  const contactPersonId = useParams()['contactPersonId']!;
  const { t } = useTranslation();
  const { data: contactperson, isLoading: isLoadingContact } =
    useGetManagementContact(contactPersonId);

  return isLoadingContact ? (
    <div className="flex h-screen items-center justify-center">
      <Icon
        role="progressbar"
        aria-label="loading"
        icon={spinnerIcon}
        size={48}
        className="animate-spin text-content-tertiary opacity-50"
      />
    </div>
  ) : !contactperson ? (
    <ErrorPage
      heading={t('error_page.not_found.title.cpr')}
      message={t('cpr.detail.error.not_found.message')}
    />
  ) : (
    !isLoadingContact && (
      <Page>
        <PageHeader
          title={`${t('common.contactperson')}: ${contactperson.fullName}`}
          previousText={t('common.button.back')}
          backHref="/beheer/contactpersonenbeheer"
        >
          <RemoveCprContactpersonButton
            data={contactperson}
            usersContactGroups={contactperson.contactGroupMemberships}
            contactpersonId={contactPersonId}
          />
        </PageHeader>
        <PersonalDataSection
          contactperson={contactperson}
          contactpersonId={contactPersonId}
        />
        <ContactGroupSection
          contactpersonId={contactPersonId}
          memberships={contactperson.contactGroupMemberships}
        />
      </Page>
    )
  );
};
